exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-Star-Icon__outline .a-Star-Icon__bg {\n  fill: white; }\n\n.a-Star-Icon__outline .a-Star-Icon__stroke {\n  fill: #ffd201; }\n\n.a-Star-Icon--transparent .a-Star-Icon__bg {\n  fill: rgba(0, 0, 0, 0); }\n\n.a-Star-Icon__filled .a-Star-Icon__bg,\n.a-Star-Icon__filled .a-Star-Icon__stroke {\n  fill: #ffd201; }\n", ""]);

// exports
